window.formatCurrency = (currency, amount, decimals = 2) => {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount / 100);
};

const store = Vue.reactive({
  state: {
    cartState: [],
    cart: null,
    location: null,
  },
  getGeolocation() {
    const cachedLocation = sessionStorage.getItem("ul");
    if (cachedLocation && cachedLocation !== "undefined") {
      this.state.location = cachedLocation;
      return;
    }
    fetch("https://ipapi.co/json/")
      .then((response) => response.json())
      .then((data) => {
        this.state.location = data.country;
        sessionStorage.setItem("ul", data.country);
      })
      .catch((error) => {
        console.error("Error fetching geolocation:", error);
      });
  },
  getCart() {
    fetch("/cart.js")
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch cart");
        return response.json();
      })
      .then((cart) => {
        this.state.cart = cart;
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  },
  async addToCart(formData) {
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(() => {
        this.getCart();
        return true;
      })
      .catch((error) => {
        console.error("Error:", error);
        return false;
      });
  },
  async clearCart() {
    return fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(() => {
        this.getCart();
        return true;
      })
      .catch((error) => {
        console.error("Error:", error);
        return false;
      });
  },
  async changeItem(itemID, itemKey, quantity) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity,
      }),
    })
      .then(async (data) => {
        const result = await data.json();
        if (result?.token) this.state.cart = result;
        else this.getCart();
        return true;
      })
      .catch((error) => {
        console.error("Error:", error);
        store.getCart();
        return false;
      });
  },
  async changeSellingPlan(itemID, sellingPlanID, quantity) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemID,
        selling_plan: sellingPlanID,
        quantity: quantity,
      }),
    })
      .then(() => {
        this.getCart();
        return true;
      })
      .catch((error) => {
        console.error("Error:", error);
        return false;
      });
  },
  isUK() {
    return (
      this.state.location === "PT" ||
      this.state.location === "GB" ||
      !this.state.location
    );
  },
});

store.getCart();
store.getGeolocation();

window.removeForceNavbarWhite = function () {
  const navbar = document.getElementById("mega-menu-wrapper");
  if (
    navbar &&
    navbar.classList.contains("force-navbar-white") &&
    window.scrollY === 0
  ) {
    navbar.classList.remove("force-navbar-white");
  }
};

window.addForceNavbarWhite = function () {
  const navbar = document.getElementById("mega-menu-wrapper");
  navbar.classList.add("force-navbar-white");
};

// Generic event function
window.trackEvent = function (eventData) {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push(eventData);
};
